import { useNavigate } from "react-router-dom";
import { T } from "../constants/theme";

export default function Footer() {
  const navigate = useNavigate();
  const setPage = (r) => navigate(`/${r}`);
  const footerLink = {
    background: "none",
    border: "none",
    color: T.muted,
    padding: 0,
    cursor: "pointer",
    fontSize: 14,
    textAlign: "left",
  };

  return (
    <footer
      style={{
        background: T.paper,
        color: T.muted,
        marginTop: 0,
      }}
    >
      <div
        style={{
          maxWidth: 1200,
          margin: "0 auto",
          padding: "70px 24px 50px",
        }}
      >
        <div
          style={{
            display: "grid",
            gridTemplateColumns:
              "minmax(250px,2fr) repeat(auto-fit,minmax(160px,1fr))",
            gap: 40,
          }}
        >
          {/* Brand */}
          <div>
            <h2
              style={{
                color: T.ink,
                margin: 0,
                fontFamily: "'Playfair Display', Georgia, serif",
                fontSize: 28,
              }}
            >
              CropBank
            </h2>

            <p
              style={{
                color: T.muted,
                marginTop: 18,
                lineHeight: 1.8,
                maxWidth: 320,
              }}
            >
              Invest directly in farm and crop projects, backed
              by live IoT data from the ground. Fund growers,
              track real returns, and watch your investment grow.
            </p>

           {/* <div
  style={{
    display: "flex",
    gap: 12,
    marginTop: 24,
  }}
>
  {[
    <FaFacebookF />,
    <FaInstagram />,
    <FaXTwitter />,
    <FaYoutube />,
  ].map((icon, i) => (
    <div
      key={i}
      style={{
        width: 42,
        height: 42,
        borderRadius: "50%",
        border: `1px solid ${T.border}`,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        cursor: "pointer",
        color: T.ink,
        fontSize: 18,
        transition: "all .25s ease",
      }}
      onMouseEnter={(e) => {
        e.currentTarget.style.background = T.gold;
        e.currentTarget.style.borderColor = T.gold;
        e.currentTarget.style.transform = "translateY(-2px)";
      }}
      onMouseLeave={(e) => {
        e.currentTarget.style.background = "transparent";
        e.currentTarget.style.borderColor =
          T.border;
        e.currentTarget.style.transform = "translateY(0)";
      }}
    >
      {icon}
    </div>
  ))}
</div> */}
          </div>

          {/* Shop */}
          <div>
            <h4
              style={{
                color: T.ink,
                marginBottom: 18,
              }}
            >
              Projects
            </h4>

            <div
              style={{
                display: "flex",
                flexDirection: "column",
                gap: 12,
              }}
            >
              <button
                onClick={() => setPage("shop")}
                style={footerLink}
              >
                All Projects
              </button>

              <button
                onClick={() => setPage("shop?cat=crop-farming")}
                style={footerLink}
              >
                Crop Farming
              </button>

              <button
                onClick={() => setPage("shop?cat=livestock-poultry")}
                style={footerLink}
              >
                Livestock & Poultry
              </button>

              <button
                onClick={() => setPage("shop?cat=farm-equipment-machinery")}
                style={footerLink}
              >
                Farm Equipment
              </button>

              <button
                onClick={() => setPage("shop?cat=irrigation-water-projects")}
                style={footerLink}
              >
                Irrigation & Water
              </button>
            </div>
          </div>

          {/* Customer Care */}
          <div>
            <h4
              style={{
                color: T.ink,
                marginBottom: 18,
              }}
            >
              Investor Support
            </h4>

            <div
              style={{
                display: "flex",
                flexDirection: "column",
                gap: 12,
              }}
            >
              <button style={footerLink}>
                Contact Us
              </button>

              <button style={footerLink}>
                How Investing Works
              </button>

              <button style={footerLink}>
                Risk Disclosure
              </button>

              <button style={footerLink}>
                FAQ
              </button>
            </div>
          </div>

          {/* Company */}
          <div>
            <h4
              style={{
                color: T.ink,
                marginBottom: 18,
              }}
            >
              Company
            </h4>

            <div
              style={{
                display: "flex",
                flexDirection: "column",
                gap: 12,
              }}
            >
              <button style={footerLink}>
                About Us
              </button>

              <button style={footerLink}>
                Sustainability
              </button>

              <button style={footerLink}>
                Careers
              </button>

              <button style={footerLink}>
                Blog
              </button>
            </div>
          </div>

          {/* Newsletter */}
          <div>
            <h4
              style={{
                color: T.ink,
                marginBottom: 18,
              }}
            >
              Stay Updated
            </h4>

            <p
              style={{
                color: T.muted,
                fontSize: 14,
                lineHeight: 1.7,
              }}
            >
              Subscribe for new project launches,
              funding updates and IoT insights.
            </p>

            <div
              style={{
                display: "flex",
                marginTop: 16,
              }}
            >
              <input
                placeholder="Email address"
                style={{
                  flex: 1,
                  padding: "12px 14px",
                  border: `1px solid ${T.border}`,
                  background: T.surface,
                  color: T.ink,
                  outline: "none",
                }}
              />

              <button
                style={{
                  background: T.gold,
                  color: T.paper,
                  border: "none",
                  padding: "0 18px",
                  cursor: "pointer",
                  fontWeight: 600,
                }}
              >
                Join
              </button>
            </div>
          </div>
        </div>
      </div>

      {/* Bottom Bar */}
      <div
        style={{
          borderTop: `1px solid ${T.border}`,
        }}
      >
        <div
          style={{
            maxWidth: 1200,
            margin: "0 auto",
            padding: "24px",
            display: "flex",
            justifyContent: "space-between",
            flexWrap: "wrap",
            gap: 20,
            color: T.muted,
            fontSize: 13,
          }}
        >
          <div>
            © 2026 CropBank. All rights reserved.
          </div>

          <div
            style={{
              display: "flex",
              gap: 20,
            }}
          >
            <span>Privacy Policy</span>
            <span>Terms & Conditions</span>
            <span>Cookies</span>
          </div>
        </div>
      </div>
    </footer>
  );
}
